import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, ConsultaDiarioOficialReducer, ConsultaDiarioOficialState } from './consulta-diario-oficial-reducer';
import { IOfficialDiaryPagedResponse } from '../../../../model/official-daily/response/official-diary-paged-response';
import { PaginationResponse } from '../../../../model/base/response/pagination-response';
import { IOfficialDiaryPagedRequest } from '../../../../model/official-daily/request/official-diary-paged-request';
import ApplicationAppService from '../../../../application/platform/application-app-service';
import dayjs from 'dayjs';

const ConsultaDiarioOficialContext = createContext<ConsultaDiarioOficialState | undefined>(undefined);
const ConsultaDiarioOficialContextDispatchContext = createContext({} as any);

const ConsultaDiarioOficialProvider = ({ children }: { children: React.ReactNode }) => {
    const applicationData = ApplicationAppService.getAuthenticationData();
    const [state, dispatch] = useReducer(ConsultaDiarioOficialReducer, { officialDiaryPagedResponse: { items: [] as IOfficialDiaryPagedResponse[], page: 0, pageSize: 1, pageCount: 0 } as PaginationResponse<IOfficialDiaryPagedResponse>, officialDiaryPagedRequest: { page: 0, pageSize: 50, number: "", year: "", clientId: applicationData?.company.id, isClosed: ""} as IOfficialDiaryPagedRequest}   as ConsultaDiarioOficialState);

    return (
        <ConsultaDiarioOficialContext.Provider value={state}>
            <ConsultaDiarioOficialContextDispatchContext.Provider value={dispatch}>
                {children}
            </ConsultaDiarioOficialContextDispatchContext.Provider>
        </ConsultaDiarioOficialContext.Provider>
    );
}

const useConsultaDiarioOficialState = () => {
    const context = useContext(ConsultaDiarioOficialContext);
    if (context === undefined) {
        throw new Error('useHomeState must be used within a HomeProvider');
    }
    return context;
}

const useConsultaDiarioOficialDispatch = () => {
    const context = useContext(ConsultaDiarioOficialContextDispatchContext);
    if (context === undefined) {
        throw new Error('useHomeDispatch must be used within a HomeProvider');
    }
    return context;
}

export { ConsultaDiarioOficialProvider, useConsultaDiarioOficialDispatch, useConsultaDiarioOficialState, ACTION_TYPES };
